import { render, staticRenderFns } from "./salutations.vue?vue&type=template&id=11b13ce4"
import script from "./salutations.vue?vue&type=script&lang=js"
export * from "./salutations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports